import {RootState} from "@/store";
import {ActionTree} from "vuex";

export const actions: ActionTree<RootState, RootState> = {

    resetStore: ({commit}: any) => {
        commit('verticals/resetState')
    }}
